/** Classi comuni dei campi, dalla guida di design ("Campo"). */
export const FIELD_INPUT =
  'h-11 w-full rounded-xl border bg-white px-3 text-base text-ink transition-colors placeholder:text-stone-500 disabled:cursor-not-allowed disabled:bg-stone-100 disabled:text-stone-500 dark:bg-stone-900 dark:text-stone-50 dark:placeholder:text-stone-400 dark:disabled:bg-stone-800';
export const FIELD_BORDER = 'border-stone-300 dark:border-stone-700';
export const FIELD_BORDER_ERROR = 'border-red-700 dark:border-red-400';
export const FIELD_LABEL = 'text-sm font-medium text-ink dark:text-stone-100';
export const FIELD_HINT = 'text-sm text-stone-600 dark:text-stone-300';
export const FIELD_ERROR = 'text-sm font-medium text-red-700 dark:text-red-400';
